export const keys = <K extends string | number | symbol>(obj: Partial<Record<K, any>>) =>
  Object.keys(obj).map((k) => k as K);

export const values = <K extends string | number | symbol, V>(obj: Partial<Record<K, V>>) =>
  Object.values(obj).map((v) => v as V);

export const omit = <T extends object, K extends keyof T>(obj: T, ...omitKeys: K[]) => {
  return keys(obj)
    .filter((key) => !omitKeys.includes(key))
    .map((key) => {
      return { [key]: obj[key] };
    })
    .reduce(merge) as Omit<T, K>;
};

export const pick = <T extends object, K extends keyof T>(obj: T, ...pickKeys: K[]) => {
  return pickKeys
    .map((key) => {
      return { [key]: obj[key] };
    })
    .reduce(merge) as Pick<T, K>;
};

export const merge = <T1, T2>(obj1: T1, obj2: T2) => {
  return { ...obj1, ...obj2 };
};

export const copy = <T>(obj: T): T => JSON.parse(JSON.stringify(obj));

export const invert = (obj: any) => {
  const inverted: any = {};

  for (const key in obj) {
    inverted[obj[key]] = key;
  }

  return inverted;
};
